import localize, { LocKeys } from "../constants/localizations";

/**
 * Extracts a human-readable error message from an API error response.
 * Handles multiple response shapes with full optional chaining.
 *
 * @param {Error|{response?: {data?: {message?: string, result?: string, errors?: string[], error?: string}}}} error
 * @returns {string} The resolved error message or a localized fallback
 */
export const extractErrorMessage = (error) => {
	const fallback =
		localize(LocKeys.SOMETHING_WENT_WRONG) || "Something went wrong";
	if (!error) return fallback;

	const data = error?.response?.data;
	const fromResult =
		typeof data?.result === "string" && data.result.trim().length > 0
			? data.result
			: null;
	const fromErrors = Array.isArray(data?.errors)
		? data.errors
				.filter((item) => typeof item === "string" && item.trim().length > 0)
				.join(", ")
		: null;

	const candidates = [
		data?.message,
		fromResult,
		fromErrors,
		data?.error,
		error?.message,
	];

	const resolved = candidates.find(
		(value) => typeof value === "string" && value.trim().length > 0
	);

	return resolved || fallback;
};

/**
 * Checks if an error is an abort/cancellation error.
 *
 * @param {Error} error
 * @returns {boolean}
 */
export const isAbortError = (error) =>
	error?.name === "AbortError" ||
	error?.name === "CanceledError" ||
	error?.code === "ERR_CANCELED";
